<template>
  <div class="course_detail p_t">
    <TopHead title="课程详情"></TopHead>
    <div class="top">
      <div class="t_title d_f ali_c">
        <span class="flex_1">{{info.commodityName}}</span>
        <div class="d_f ali_c">
          <template v-for="(im,ix) in info.hotTagList" :key="ix">
            <img :src="imgArr[Number(im-1)]" alt="" v-if="im">
          </template>
        </div>
      </div>
      <div class="t_c">{{info.synopsis}}</div>
      <div class="t_i t_a">
        <img :src="info.commodityCoverOne" alt="">
        <div class="price">
          <span v-if="info.sellPrice && info.sellPrice>0">￥{{info.sellPrice ? info.sellPrice/100 : 0}}</span>
          <span class="cut" v-if="info.marketPrice && info.marketPrice>0">原价：￥{{info.marketPrice ? info.marketPrice/100 : 0}}</span>
        </div>
      </div>
    </div>

    <div class="items_out" v-for="(item,index) in info.detailList" :key="index">
      <div class="io_title d_f ali_c">
        <div class="or"></div>
        <span>{{item.title}}</span>
      </div>
      <div class="try_break" v-html="item.commodityContent"></div>
    </div>
    <div class="items_out">
      <div class="io_title d_f ali_c">
        <div class="or"></div>
        <span>教学师资</span>
      </div>
      <div class="teacher" v-for="(item,index) in info.teacherList" :key="index">
        <div class="t_name t_a">
          <van-image fit="cover" :src="item.picUrl"/>
          <div>{{item.teacherName}}</div>
        </div>
        <div class="t_text blue_t"><span v-for="(itm,idx) in item.tagList" :key="idx">{{itm+'、'}}</span></div>
        <div class="t_text">教师简介：{{item.synopsis}}</div>
      </div>
    </div>
  </div>
</template>

<script>
  import classRe from '../assets/img/class_re.png'
  import classJing from '../assets/img/class_jing.png'
  import classHui from '../assets/img/class_hui.png'
  export default {
    name: "CourseDetail",
    data() {
      return {
        imgArr:[classRe,classJing,classHui],
        info:{},
      }
    },
    created(){
      this.getCommodity()
    },
    methods: {
      //查询商品详情
      getCommodity(){
        this.$api.getCommodity({commodityId:this.$route.query.commodityId}).then(res => {
          this.info = res.data;
        })
      }
    }
  }
</script>

<style scoped lang="scss">

  .items_out{
    .try_break{
      ::v-deep span{
        word-break: break-all;
        white-space: pre-wrap;
      }
    }
    ::v-deep img{
      max-width: 100%;
      height: auto;
    }
    .teacher{
      .t_text{
        margin-bottom: 15px;
      }
      .t_name{
        font-size: 15px;
        margin-bottom:13px;
        font-weight: bold;
        color: #333333;
      }
      .van-image{
        margin-bottom: 12px;
        margin: 0 auto;
        width: 131px;
      }
      font-size: 14px;
      font-weight: 500;
      color: #333333;
    }
    .io_title{
      .or{
        width: 4px;
        height: 15px;
        background: #FF7B22;
        margin-right: 4px;
      }
      margin-bottom: 16px;
      font-size: 15px;
      font-weight: bold;
      color: #333333;
    }
    padding: 21px 13px 0 21px;
  }
  .top{
    .t_i{
      .price{
        .cut{
          font-size: 10px;
          font-weight: 500;
          color: #8C8C8C;
          margin-left: 22px;
          text-decoration: line-through;
        }
        vertical-align: middle;
        font-size: 18px;
        font-weight: bold;
        color: #FF8432;
      }
      img{
        width: 294px;
        height: 205px;
        margin-bottom: 17px;
      }
    }
    .t_c{
      font-size: 14px;
      font-weight: 500;
      margin-bottom: 26px;
    }
    .t_title{
      img{
        width: 12px;
        height: auto;
        margin-left: 10px;
      }
      font-size: 18px;
      font-weight: bold;
      color: #333333;
      margin-bottom: 13px;
    }
    padding: 15px 13px 30px;
    border-bottom: 10px solid #F0F0F0;
  }

</style>
